import axios from 'axios';

export async function getHistory(navigate) {
    try {
        const result = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/client/history`,
            { withCredentials: true, validateStatus: () => true }
        );
        if (!result.data.success && (result.data.error.code === 'NO_TOKEN' || result.data.error.code === 'INVALID_TOKEN')) {
            localStorage.removeItem('user');
            navigate('/login');
        }
        return result.data;
    } catch (_) {
        return {success: false, data: [], error: {code: "SERVER_ERROR", message: "Impossible de contacter le serveur"} };
    }
}

export async function putHistory(month, history_data, navigate) {
    try {
        const result = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/client/history`,
            { month, history_data },
            { withCredentials: true, validateStatus: () => true }
        );
        if (!result.data.success && (result.data.error.code === 'NO_TOKEN' || result.data.error.code === 'INVALID_TOKEN')) {
            localStorage.removeItem('user');
            navigate('/login');
        }
        return result.data;
    } catch (_) {
        return {success: false, data: [], error: {code: "SERVER_ERROR", message: "Impossible de contacter le serveur"} };
    }
}